import {
  ADD_VACATION,
  DELETE_VACATION,
  GET_VACATIONS,
  GET_VACATIONS_DASHBOARD,
  GET_VACATION_CONTROL,
  VACATION_CONTROL_ERROR,
  VACATION_ERROR,
  UPDATE_VACATION,
} from 'src/actions/types'

const initialState = {
  vacations: {
    data: [],
    current_page: 1,
  },
  dashboard: null,
  filters: {},
  loading: true,
  error: {},
  control: { data: [], current_page: 1 },
  controlLoading: true,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case GET_VACATIONS:
      return {
        ...state,
        vacations: payload,
        filters: payload.filters,
        loading: false,
      }
    case GET_VACATIONS_DASHBOARD:
      return {
        ...state,
        dashboard: payload,
        loading: false,
      }
    case GET_VACATION_CONTROL:
      return {
        ...state,
        control: payload,
        controlLoading: false,
      }
    case VACATION_CONTROL_ERROR:
      return {
        ...state,
        error: payload,
        controlLoading: false,
      }
    case ADD_VACATION:
      return {
        ...state,
        vacations: { data: [payload, ...state.vacations.data] },
        loading: false,
      }
    case UPDATE_VACATION: {
      return {
        ...state,
        vacations: {
          ...state.vacations,
          data: state.vacations.data.map((vacation) =>
            vacation.id === payload.id ? { ...vacation, ...payload } : vacation,
          ),
        },
        loading: false,
      }
    }
    case DELETE_VACATION:
      return {
        ...state,
        vacations: { data: state.vacations.data.filter((vacation) => vacation.id !== payload) },
        loading: false,
      }
    case VACATION_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      }
    default:
      return state
  }
}
